<section class="section-white" *ngIf="cards">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-32">Listen to other podcasts</h2>
    <!-- ================================ -->
    <div class="new_item_wrapper pt-4" *ngIf="cards?.length">
      <div class="flex-col gap-48">
        <div class="multi-row-grid">
          <div class="blog-container" *ngFor="let card of cards">
            <ng-container
              *ngTemplateOutlet="figureTemplate; context: { item: card }"
            ></ng-container>
          </div>
        </div>

        <div class="single-row-scroll">
          <div class="item blog-container-mobile" *ngFor="let card of cards">
            <ng-container
              *ngTemplateOutlet="figureTemplate; context: { item: card }"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #figureTemplate let-item="item">
  <ng-container *ngIf="item?.fields?.title">
    <div class="blog-image">
      <img
        class="responsive-radius-xl"
        src="{{ item.fields.webinarAndPodcastMedia[0].fields.file.url }}"
        alt="{{ item.fields.webinarAndPodcastMedia[0].fields.title }}"
      />
    </div>
    <div class="latest-news-content">
      <h5 class="latest-news-heading">
        {{ item?.fields?.title }}
      </h5>
      <p>
        <time
          >{{ item?.fields?.webinarAndPodcastDate | date: 'longDate' }} ·
        </time>
        <span class="status text-light"
          >{{ item?.fields?.listeningTime }}
        </span>
      </p>
    </div>
    <a
      href="{{'About-Us/Media-and-Events/Webinars-and-Podcasts/' + item.fields.blogId | urlParams:queryParams}}"
      class="stretched-link"
    ></a>
  </ng-container>
</ng-template>
